import i18n from '@/i18n';

export default [
  {
    path: '/terms',
    name: 'terms',
    meta: {
      loadState: false,
      auth: false,
      isAuthPage: false,
      title: i18n.global.t('terms_and_conditions'),
    },
    component: () => import('../../views/terms/Terms.vue'),
  },
];
